<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="p-card-field">
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Send to <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <input class="input_tmp_validator" id="type_id">
            <Dropdown class="p-col-width-a" v-model="type" :options="types" :disabled="mode=='edit'"
              optionValue="value" optionLabel="label" placeholder="Choose" v-on:change="changeType"
            />
          </div>
        </div>
        <div v-if="type=='USER'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d1">Choose user <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <input class="input_tmp_validator" id="seluser_id">
              <v-select :disabled="mode=='edit'" :clearable="false" title="User" id= "a1" :filterable="false" placeholder="Choose" v-model="selUser" :options="listUser" label="fullname" @search="fetchOptionsUser" class="p-col-width-a" @input="addNewUser">
                <span slot="no-options" @click="$refs.select.open = false">
                  No data
                </span>
              </v-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <div v-if="mode=='edit'" class="p-col">
              <label v-for="(user, index) in list_users" :key="index" class="cus-tags">
                <span>
                  {{user.fullname}}
                </span>
              </label>
            </div>
            <div v-else class="p-col">
              <label v-for="(user, index) in list_users" :key="index" class="cus-tags">
                <span class="cs-tag">
                  {{user.fullname}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeUser(index)"></i>
              </label>
            </div>
          </div>
        </div>
        <div v-if="type=='CLUB'">
          <div class="p-field p-grid">
            <label class="p-col-fixed in-d1">Choose club <span style="color:red">*</span></label>
          </div>
          <div class="p-field p-grid">
            <div class="p-col">
              <input class="input_tmp_validator" id="selclub_id">
              <v-select :disabled="mode=='edit'" :clearable="false" title="Club" id= "a2" :filterable="false" placeholder="Choose" v-model="selClub" :options="listClub" label="name" @search="fetchOptionsClub" class="p-col-width-a" @input="addNewClub">
                <span slot="no-options" @click="$refs.select.open = false">
                  No data
                </span>
              </v-select>
            </div>
          </div>
          <div class="p-field p-grid">
            <div v-if="mode=='edit'" class="p-col">
              <label v-for="(club, index) in list_clubs" :key="index" class="cus-tags">
                <span>
                  {{club.name}}
                </span>
              </label>
            </div>
            <div v-else class="p-col">
              <label v-for="(club, index) in list_clubs" :key="index" class="cus-tags">
                <span class="cs-tag">
                  {{club.name}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeClub(index)"></i>
              </label>
              
            </div>
          </div>
        </div>

        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Title (EN) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="title_en" id="title_en_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Short description (EN) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="short_description_en" id="short_description_en_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Description (EN) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <input class="input_tmp_validator" id="description_en_id">
            <CkditorCore :key="content_key_en" :contentSet="this.description_en" @newdata="handleDataCkditor($event,'content_en')"></CkditorCore>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Title (KR) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="title_ko" id="title_ko_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Short description (KR) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="short_description_ko" id="short_description_ko_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Description (KR) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <input class="input_tmp_validator" id="description_ko_id">
            <CkditorCore :key="content_key_ko" :contentSet="this.description_ko" @newdata="handleDataCkditor($event,'content_ko')"></CkditorCore>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Title (VN) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="title_vi" id="title_vi_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Short description (VN) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="short_description_vi" id="short_description_vi_id" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d1">Description (VN) <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <input class="input_tmp_validator" id="description_vi_id">
            <CkditorCore :key="content_key_vi" :contentSet="this.description_vi" @newdata="handleDataCkditor($event,'content_vi')"></CkditorCore>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
        <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning"
            style="width: 120px !important;"
          />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"

          />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"
          />
        </template>
      </Toolbar>
    </div>
    
  </form>
</template>
<script>
import DataServices from '@/core/DataServices';
import CkditorCore from '../CkditorCore';
export default {
  components: {
    CkditorCore
  },
  props: {
    mode: String,
    model: Object,
    categories: Array,
    requests: Array
  },
  data() { 
    return {
      type : null,
      title_en: '',
      title_vi: '',
      title_ko: '',
      short_description_en : '',
      short_description_vi : '',
      short_description_ko : '',
      description_en: '',
      description_vi: '',
      description_ko: '',
      types: [
        { value: 'ALL_USER', label: 'All of user',style: 'color:  #000000;'},
        { value: 'ALL_CLUB', label: 'All of club',style: 'color:  #000000;'},
        { value: 'CLUB', label: 'Clubs',style: 'color:  #000000;'},
        { value: 'USER', label: 'Users',style: 'color:  #000000;'},
      ],
      validationErrors: {},
      list_users : [],
      selUser : null,
      listUser : [],
      selClub : null,
      listClub : [],
      list_clubs : [],
      content_key_en : 1,
      content_key_ko : 11,
      content_key_vi : 22,
    }
  },
  async mounted () {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("this.model",this.model)
      this.type = this.model.type
      if(this.model.type == 'USER'){
        //gọi lấy danh sách user
        this.getDataUser(this.model.list_ids)
      }else if(this.model.type == 'CLUB'){
        this.getDataClub(this.model.list_ids)
      }
      if(this.model.notification_lang.length > 0){
        for (let i = 0; i < this.model.notification_lang.length; i++) {
          const e = this.model.notification_lang[i];
          if(e.lang == 'en'){
            this.title_en = e.title
            this.short_description_en = e.short_description
            this.description_en = e.description
            this.content_key_en++;
          }else if(e.lang == 'ko'){
            this.title_ko = e.title
            this.short_description_ko = e.short_description
            this.description_ko = e.description
            this.content_key_ko++;
          }else if(e.lang == 'vi'){
            this.title_vi = e.title
            this.short_description_vi = e.short_description
            this.description_vi = e.description
            this.content_key_vi++;
          }
        }
      }
    }
  },
  methods: {
    async getDataUser(ids){
      //lấy các user được chọn
      var {data} = await this.$apollo.query({
        query: DataServices.getList('users',{"fields" :`id fullname`}),
        variables: {
          where_key: {
            id: {'_in': ids},
          }
        },
      })
      var users = data[Object.keys(data)];
      var list_user = []
      if (users.length > 0) {
        for (let i = 0; i < users.length; i++) {
          const e = users[i];
          var fullname = e.fullname ? e.fullname : e.id
          list_user.push({
            id : e.id,
            fullname : fullname
          })
        }
      }
      this.list_users = list_user
    },
    async getDataClub(ids){
      //lấy các user được chọn
      var {data} = await this.$apollo.query({
        query: DataServices.getList('clubs',{"fields" :`id club_name`}),
        variables: {
          where_key: {
            id: {'_in': ids},
          }
        },
      })
      var clubs = data[Object.keys(data)];
      var list_club = []
      if (clubs.length > 0) {
        for (let i = 0; i < clubs.length; i++) {
          const e = clubs[i];
          list_club.push({
            id : e.id,
            name : e.club_name
          })
        }
      }
      this.list_clubs = list_club
    },
    handleDataCkditor: function(e,key) {
      var dataContent = (e.length) ? e[0]:'';
      if (key == 'content_en'){
        this.description_en = dataContent;
      }else if (key == 'content_vi'){
        this.description_vi = dataContent;
      }else if (key == 'content_ko'){
        this.description_ko = dataContent;
      }
    },
    addNewUser(){
      // console.log("check",this.selUser)
      if(this.selUser){
        var check = false
        for (let i = 0; i < this.list_users.length; i++) {
          const e = this.list_users[i];
          if(e.id == this.selUser.id){
            check = true
            break
          }
        }
        if(check == false){
          this.list_users.push(this.selUser)
        }
      }
      this.selUser = null
    },
    addNewClub(){
      if(this.selClub){
        var check = false
        for (let i = 0; i < this.list_clubs.length; i++) {
          const e = this.list_clubs[i];
          if(e.id == this.list_clubs.id){
            check = true
            break
          }
        }
        if(check == false){
          this.list_clubs.push(this.selClub)
        }
      }
      this.selClub = null
    },
    async changeType(){
      var type = this.type
      if(type == 'USER'){
        this.fetchOptionsUser('',true)
        this.list_users = []
      }else if(type == 'CLUB'){
        this.fetchOptionsClub('',true)
        this.list_clubs = []
      }else{
        this.list_users = []
        this.list_clubs = []
      }
    },
    async removeUser(index){
      this.list_users.splice(index, 1)
    },
    async removeClub(index){
      this.list_clubs.splice(index, 1)
    },
    async validateData() {
      if(this.$commonFuction.isEmpty(this.type)){
        document.getElementById("type_id").setCustomValidity('Please choose send to');
      }else{
        document.getElementById("type_id").setCustomValidity('');
        if(this.type == "USER"){
          if(this.list_users && this.list_users.length > 0){
            document.getElementById("seluser_id").setCustomValidity('');
          }else{
            document.getElementById("seluser_id").setCustomValidity('Please choose user');
          }
        }else if(this.type == "CLUB"){
          if(this.list_clubs && this.list_clubs.length > 0){
            document.getElementById("selclub_id").setCustomValidity('');
          }else{
            document.getElementById("selclub_id").setCustomValidity('Please choose club');
          }
        }
      }

      if (this.$commonFuction.isEmpty(this.title_en)) {
        document.getElementById("title_en_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("title_en_id").setCustomValidity("");
      }
      if (this.$commonFuction.isEmpty(this.short_description_en)) {
        document.getElementById("short_description_en_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("short_description_en_id").setCustomValidity("");
      }
      if (this.$commonFuction.isEmpty(this.description_en)) {
        document.getElementById("description_en_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("description_en_id").setCustomValidity("");
      }
      
      if (this.$commonFuction.isEmpty(this.title_ko)) {
        document.getElementById("title_ko_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("title_ko_id").setCustomValidity("");
      }
      if (this.$commonFuction.isEmpty(this.short_description_ko)) {
        document.getElementById("short_description_ko_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("short_description_ko_id").setCustomValidity("");
      }
      if (this.$commonFuction.isEmpty(this.description_ko)) {
        document.getElementById("description_ko_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("description_ko_id").setCustomValidity("");
      }
      
      if (this.$commonFuction.isEmpty(this.title_vi)) {
        document.getElementById("title_vi_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("title_vi_id").setCustomValidity("");
      }
      if (this.$commonFuction.isEmpty(this.short_description_vi)) {
        document.getElementById("short_description_vi_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("short_description_vi_id").setCustomValidity("");
      }
      if (this.$commonFuction.isEmpty(this.description_vi)) {
        document.getElementById("description_vi_id").setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        document.getElementById("description_vi_id").setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }
    },
    async fetchOptionsUser(search, loading){
      console.log(loading);
      console.log('search',search);
      var where_key = {
        deleted : {_eq : false},
        active : {_eq : true},
        role: {_eq: "user"},
      }
      if(search !== '' && search !== null){
        where_key['plain_fullname'] = {_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"}
      }
      let {data} = await this.$apollo.query({
          query: DataServices.getList('users',{"fields" : `id fullname`}),
          variables: {
            where_key: where_key,
            orderBy:{created_at : 'desc'}
          },
          fetchPolicy: 'no-cache'
        })
        var list = data[Object.keys(data)];
        var list_user = [];
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          var fullname = e.fullname ? e.fullname : e.id
          list_user.push({id : e.id, fullname : fullname});
        }
        this.listUser = list_user;
    },
    async fetchOptionsClub(search, loading){
      console.log(loading);
      var where_key = {
        deleted : {_eq : false},
      }
      if(search !== '' && search !== null){
        where_key['club_plainname'] = {_ilike: "%"+this.$commonFuction.SkipVN(search).trim()+"%"}
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('clubs',{"fields" : `id club_name`}),
        variables: {
          where_key: where_key,
          orderBy:{created_at : 'desc'}
        },
        fetchPolicy: 'no-cache'
      })
      var list = data[Object.keys(data)];
      var list_club = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_club.push({id : e.id, name : e.club_name});
      }
      this.listClub = list_club;
    },
    
    backToList() {
      this.$emit('back');
    },
    async saveData() {
     this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }

      if (Object.entries(this.validationErrors).length === 0) {
        var list_ids = []
        if(this.mode !== 'edit'){
          if(this.type == 'USER'){
            for (let i = 0; i < this.list_users.length; i++) {
              list_ids.push(this.list_users[i].id)
            }
          }else if(this.type == 'CLUB'){
            for (let i = 0; i < this.list_clubs.length; i++) {
              list_ids.push(this.list_clubs[i].id)
            }
          }
        }
        var params = {
          type : this.type,
          list_ids : list_ids,
          title_en: this.title_en,
          title_vi: this.title_vi,
          title_ko: this.title_ko,
          short_description_en : this.short_description_en,
          short_description_vi : this.short_description_vi,
          short_description_ko : this.short_description_ko,
          description_en: this.description_en,
          description_vi: this.description_vi,
          description_ko: this.description_ko,
        }
        // console.log("params",params)
        this.$emit('save', params);
      }
    },
    onChange(event) {
      this.category_id = event.value.id;
    },
    // dropdownChange(event) {
    //   this.types = event.value;
    //   if (this.types && this.types.value === 'USER') this.users = this.lstUsers;
    // },
    onFileClear(index) {
      if (this.images !== undefined && this.images.length > 0) {
        this.images.splice(index, 1);
      }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
      if(files.length > 0) {
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }
          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 1MB");
          } else {
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
    },
    
  }
}
</script>
<style lang="scss">
html {
  scroll-padding-top: 100px;
}

.p-col-width-a{
  max-width: 600px
}
.in-d1 {
  font-weight: 700;
}
.cus-tags{
  border-radius: 18px;
  padding: 8px;
  margin-right: 10px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
</style>